import React from "react";
import Layout from "../Layout/Layout";
import "../CustomCSS/NotFound.css"; // Make sure to create this CSS file
import notfound from "../../Assests/imgs/app/app-1/notfound.png";

const NotFound = () => {
  return (
    <Layout>
      <div className="error-container">
        
        <div className="error-content">
        <p className="not-error-message">
            Oops! The page you're looking for seems to have taken a wrong turn.
          </p>
          <img 
            src={notfound} 
            alt="404 Error" 
            className="error-image" 
          />
          <h1 className="error-title">404</h1>
          
          <p className="error-submessage">
            The road you're trying to travel doesn't exist or has been moved.
          </p>
          <button 
            className="error-button" 
            onClick={() => window.location.href = '/'}
          >
            Back to Home
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;